import { 
  Grid, 
} from '@mui/material'; 
import { useTheme } from '@mui/material/styles'; 
import React from 'react';
import { EntityCard } from './EntityCard';

const useStyles =  (theme) => ({
  cardDescription: {
    maxHeight: '70px !important',
    overflowY: 'auto !important',
  },
  container: {
    justifyContent: 'center !important',
  },
  tag: {
    fontWeight: `${theme.typography.fontWeightBold} !important`,
    paddingRight: '4px !important',
  },
  checkbox: {
    padding: '1px !important',
  },
});

export const EntityCards = React.memo(
  (props) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    return (
      <Grid container spacing={1} sx={classes.container}>
        {props.entities.map((entity) => (
          <EntityCard
            key={entity.id}
            minGridWith={props.minGridWith}
            entity={entity}
            showParticipants={props.showParticipants}
            nrHosts={entity.visitors && entity.visitors.length}
            refreshEntityList={props.refreshEntityList}
          />
        ))}
      </Grid>
    );
  },
  (prevProps, nextProps) =>
    prevProps.totalVisitors === nextProps.totalVisitors &&
    prevProps.nrEntities === nextProps.nrEntities &&
    prevProps.showParticipants === nextProps.showParticipants &&
    prevProps.entities.length > 0 &&
    nextProps.entities.length > 0 &&
    prevProps.entities[0].id === nextProps.entities[0].id
);
EntityCards.displayName = 'EntityCards';
